import { Module } from 'vuex';
import { RootState } from '../rootState';
import { ITranslationDefault } from './types';
import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';
import { getDefaultState } from './initialState';

const state: ITranslationDefault = getDefaultState();

export const translation: Module<ITranslationDefault, RootState> = {
    state,
    actions,
    getters,
    mutations,
    namespaced: true
};
